// extracted by mini-css-extract-plugin
module.exports = {"boxItemImage":"GalleryItem_boxItemImage__wqutu","boxItemImageFull":"GalleryItem_boxItemImageFull__GOMuR","description":"GalleryItem_description__GlkQL"};